import type { Dispatch } from 'react';
import { PageLayout, SummariesLayout } from '../config/types';
import { LayoutAction } from '../context';
import {
  SET_ASSET_DETAILS_ID,
  SET_ASSET_DETAILS_LAYOUT,
  SET_DONT_SHOW_PRESENTER_SETTING,
  SET_PAGE_LAYOUT,
  SET_PRESENTER_MODE,
  SET_SUMMARIES_LAYOUT,
  SET_VISIBLE_PRESENTER_COMPONENTS,
} from './actionTypes';

export const setPageLayout = (
  pageLayout: PageLayout,
  dispatch: Dispatch<LayoutAction>,
) => {
  localStorage.setItem(SET_PAGE_LAYOUT, pageLayout);
  dispatch({
    type: SET_PAGE_LAYOUT,
    payload: pageLayout,
  });
};

export const setAssetDetailsLayout = (
  assetDetaillayout: PageLayout,
  dispatch: Dispatch<LayoutAction>,
) => {
  dispatch({
    type: SET_ASSET_DETAILS_LAYOUT,
    payload: assetDetaillayout,
  });
};

export const setSummariesLayout = (
  layout: SummariesLayout,
  dispatch: Dispatch<LayoutAction>,
) => {
  localStorage.setItem(SET_SUMMARIES_LAYOUT, layout.toString());
  dispatch({
    type: SET_SUMMARIES_LAYOUT,
    payload: layout,
  });
};

export const setAssetDetailsAssetId = (
  assetDetailsAssetId: string | null,
  manual: boolean,
  dispatch: Dispatch<LayoutAction>,
) => {
  dispatch({
    type: SET_ASSET_DETAILS_ID,
    payload: {
      assetDetailsAssetId,
      manual,
    },
  });
};

export const setPresenterModeActive = (
  presenterModeActive: boolean,
  dispatch: Dispatch<LayoutAction>,
) => {
  if (presenterModeActive) {
    setSummariesLayout('default', dispatch);
    setAssetDetailsAssetId(null, true, dispatch);
  }

  dispatch({
    type: SET_PRESENTER_MODE,
    payload: presenterModeActive,
  });
};

export const setVisiblePresenterComponents = (
  visiblePresenterComponents: {
    [projectCode: string]: {
      [assetType: string]: Array<string>
    }
  },
  dispatch: Dispatch<LayoutAction>,
) => {
  localStorage.setItem(
    SET_VISIBLE_PRESENTER_COMPONENTS,
    JSON.stringify(visiblePresenterComponents),
  );
  dispatch({
    type: SET_VISIBLE_PRESENTER_COMPONENTS,
    payload: visiblePresenterComponents,
  });
};

export const setShowPresenterSetting = (
  dontShowPresenterSetting: boolean,
  dispatch: Dispatch<LayoutAction>,
) => {
  localStorage.setItem(SET_DONT_SHOW_PRESENTER_SETTING, dontShowPresenterSetting.toString());
  dispatch({
    type: SET_DONT_SHOW_PRESENTER_SETTING,
    payload: dontShowPresenterSetting,
  });
};
